module.exports = __webpack_public_path__ + "img/RECREATION_SAMEACTION.3e408ee0.jpg";